<div class="flex-column gap p-2">
    <app-date-input
        [form]="form"
        [showTime]="true"
        id="date"
    ></app-date-input>
    <app-rrule-input
        [form]="form"
        id="recurrenceRule"
        [showStartDate]="false"
    ></app-rrule-input>
</div>
